"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddDriverPriceOutputWidget = void 0;
var React = require("react");
var commonFunctions_1 = require("../../../commonFunctions");
var IPTDisclamer_1 = require("../../../components/IPTDisclamer");
var PremiumOutputWidget_1 = require("../PremiumOutputWidget");
var components_1 = require("@athena-portal/components");
var services_1 = require("@falcon/services");
var moment = require("moment");
var AddDriverPriceOutputWidget = /** @class */ (function (_super) {
    __extends(AddDriverPriceOutputWidget, _super);
    function AddDriverPriceOutputWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.additionalPremium = _this.props.interaction.factors.additionalPremium;
        _this.returnPremium = _this.props.interaction.factors.returnPremium;
        _this.startDate = _this.props.interaction.headerInfo.startDate;
        _this.endDate = _this.props.interaction.headerInfo.endDate;
        _this.renderIfPaymentNotNeeded = function (priceExplanationSection) {
            return (React.createElement("div", { className: "_panel-dashboard form-group font-weight-extra-light text-center" },
                React.createElement("p", null, "Good news, there is no extra cost for the change you made!"),
                priceExplanationSection,
                React.createElement(IPTDisclamer_1.default, { cssClass: "text-center mt-4 mx-4 mb-0" })));
        };
        _this.renderPermanentDriverPrice = function (priceExplanationSection) {
            var driver = _this.props.interaction.additionalDrivers[_this.props.interaction.additionalDrivers.length - 1];
            return (React.createElement("div", { className: "_panel-dashboard form-group font-weight-extra-light text-center" },
                React.createElement("div", { id: "price", className: "fs-24 letter-spacing-n35 font-weight-bold font-family-display mb-2" }, _this.additionalPremium > 0 ? "".concat((0, commonFunctions_1.getAmountToDisplay)(_this.additionalPremium)) : "Refund of ".concat((0, commonFunctions_1.getAmountToDisplay)(_this.returnPremium))),
                React.createElement("div", null,
                    "to add permanent driver ",
                    driver.firstName,
                    " ",
                    driver.lastName,
                    " from ",
                    moment(_this.startDate).format("DD MMM")),
                priceExplanationSection,
                React.createElement(IPTDisclamer_1.default, { cssClass: "text-center mx-4 mb-0" })));
        };
        _this.renderTemporaryDriverPrice = function (priceExplanationSection) {
            window.sessionStorage.setItem("mtaVrn", _this.props.interaction.vehicles[0].registrationNumber);
            window.sessionStorage.setItem("mtaAdditionalPremium", _this.additionalPremium.toString());
            var driver = _this.props.interaction.temporaryDrivers[_this.props.interaction.temporaryDrivers.length - 1];
            return (React.createElement("div", { className: "_panel-dashboard form-group font-weight-extra-light text-center" },
                React.createElement("div", { id: "price", className: "fs-24 letter-spacing-n35 font-weight-bold font-family-display mb-2" }, (0, commonFunctions_1.getAmountToDisplay)(_this.additionalPremium)),
                React.createElement("div", null,
                    "to add temporary driver ",
                    driver.firstName,
                    " ",
                    driver.lastName,
                    " for",
                    React.createElement("b", { className: "font-weight-semi-bold" },
                        " ",
                        driver.temporaryDriverDaysAdjustmentLength,
                        " days "),
                    "cover (",
                    moment(_this.startDate).format("DD MMM"),
                    " - ",
                    moment(_this.endDate).format("DD MMM"),
                    ")"),
                priceExplanationSection,
                React.createElement(IPTDisclamer_1.default, { cssClass: "text-center mx-4 mb-0" })));
        };
        return _this;
    }
    AddDriverPriceOutputWidget.prototype.render = function () {
        if (this.state.policies && this.state.subscription) {
            var priceExplanationSection = this.renderPricingExplanationSection();
            if (this.props.interaction.process === services_1.INTERACTION_PROCESS_MTA_ADD_PERMANENT_DRIVER &&
                (this.additionalPremium && this.additionalPremium > 0) || (this.returnPremium && this.returnPremium > 0)) {
                return this.renderPermanentDriverPrice(priceExplanationSection);
            }
            else if (this.props.interaction.process === services_1.INTERACTION_PROCESS_MTA_ADD_TEMPORARY_DRIVER && this.additionalPremium && this.additionalPremium > 0) {
                return this.renderTemporaryDriverPrice(priceExplanationSection);
            }
            else {
                return this.renderIfPaymentNotNeeded(priceExplanationSection);
            }
        }
        else {
            return React.createElement(components_1.Overlay, { show: true });
        }
    };
    AddDriverPriceOutputWidget.prototype.renderPricingExplanationSection = function () {
        var motorPolicies = this.state.policies.filter(function (policy) { return policy.products.includes("PropositionFalconMotorInsurance"); });
        var neverHigherAmount = (0, commonFunctions_1.getNeverHigherPeriodAmount)(this.props.interaction);
        return (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "text-center mx-4 mb-0" }, "Your price could go up or down, but we guarantee you won't pay more than"),
            React.createElement("p", { className: "text-center font-weight-bold mx-4" }, (0, commonFunctions_1.getNeverHigherPeriodWording)(this.props.interaction, neverHigherAmount, motorPolicies))));
    };
    return AddDriverPriceOutputWidget;
}(PremiumOutputWidget_1.PremiumOutputWidget));
exports.AddDriverPriceOutputWidget = AddDriverPriceOutputWidget;
//# sourceMappingURL=AddDriverPriceOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/AddDriverPriceOutputWidget.js
// module id = 3159
// module chunks = 0